import React from "react";
import { UseFormRegister } from "react-hook-form";

import SignUpFormLayout from "~/common/components/signUp/SignUpFormLayout";
import SignUpProgress from "~/common/components/signUp/SignUpProgress";
import Input from "~/common/components/ui/Input";
import { formatPhoneNumberField } from "~/common/utils";
import {
  SignUpPatientSchemaType,
  UserMobileSchemaType,
} from "~/patients/utils";
import { FormErrors } from "~/patients/utils/types/forms";

interface PatientMobileFormProps {
  handleGoBack: () => void;
  totalSteps: number;
  register: UseFormRegister<SignUpPatientSchemaType>;
  onNext: () => Promise<void>;
  step: number;
  errors?: FormErrors<UserMobileSchemaType>;
}

const PatientMobileForm = ({
  onNext,
  register,
  handleGoBack,
  totalSteps,
  errors,
  step,
}: PatientMobileFormProps) => {
  return (
    <>
      <SignUpProgress step={step} totalSteps={totalSteps} />
      <SignUpFormLayout
        title="Your mobile number"
        description="You will receive a verification code via SMS."
        handleGoBack={handleGoBack}
        handleData={onNext}
      >
        <Input
          autoFocus
          id="phone_number"
          label="Mobile number"
          {...register("phone_number.phone_number")}
          {...formatPhoneNumberField<SignUpPatientSchemaType>(
            "phone_number.phone_number",
            register,
          )}
          error={errors?.phone_number?.message}
        />
      </SignUpFormLayout>
    </>
  );
};

export default PatientMobileForm;
